import React from 'react';
import Layout from '../../components/layout/Layout';
import Section from '../../components/layout/Section';
import Container from '../../components/layout/Container';

const PrivacyPolicy: React.FC = () => {
  return (
    <Layout>
      <Section className="py-16">
        <Container>
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
            <div className="prose prose-lg">
              <p className="mb-6">Last updated: May 7, 2025</p>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
                <p>
                  CodeMyAI ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. This privacy policy describes how we collect, use, and share your information when you use our website and services.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Information We Collect</h2>
                <ul className="list-disc pl-6 mb-4">
                  <li>Personal information (name, email address, contact details)</li>
                  <li>Usage data and analytics</li>
                  <li>Technical data (IP address, browser information)</li>
                  <li>Communication preferences</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">How We Use Your Information</h2>
                <ul className="list-disc pl-6 mb-4">
                  <li>To provide and maintain our services</li>
                  <li>To communicate with you about our services</li>
                  <li>To improve our website and user experience</li>
                  <li>To comply with legal obligations</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Data Protection</h2>
                <p>
                  We implement appropriate technical and organizational measures to ensure the security of your personal data. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Your Rights</h2>
                <p>You have the right to:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Access your personal data</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Request data portability</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                  <br />
                  Email: privacy@CodeMyAI.com
                </p>
              </section>
            </div>
          </div>
        </Container>
      </Section>
    </Layout>
  );
};

export default PrivacyPolicy;